
export enum E_SupportedLocales {
  af = 'af',
  ar = 'ar',
  be = 'be',
  bg = 'bg',
  bn = 'bn',
  ca = 'ca',
  cs = 'cs',
  cy = 'cy',
  da = 'da',
  de = 'de',
  el = 'el',
  enUS = 'en-US',
  enGB = 'en-GB',
  eo = 'eo',
  es = 'es',
  et = 'et',
  eu = 'eu',
  fa = 'fa',
  fi = 'fi',
  fo = 'fo',
  fr = 'fr',
  ga = 'ga',
  gl = 'gl',
  gu = 'gu',
  he = 'he',
  hi = 'hi',
  hr = 'hr',
  ht = 'ht',
  hu = 'hu',
  hy = 'hy',
  id = 'id',
  is = 'is',
  it = 'it',
  ja = 'ja',
  ka = 'ka',
  kk = 'kk',
  km = 'km',
  kn = 'kn',
  ko = 'ko',
  ky = 'ky',
  lb = 'lb',
  lo = 'lo',
  lt = 'lt',
  lv = 'lv',
  me = 'me',
  mk = 'mk',
  ml = 'ml',
  mr = 'mr',
  ms = 'ms',
  my = 'my',
  nb = 'nb',
  ne = 'ne',
  nl = 'nl',
  nn = 'nn',
  paIN = 'pa-IN',
  pl = 'pl',
  pt = 'pt',
  ro = 'ro',
  ru = 'ru',
  sk = 'sk',
  sl = 'sl',
  sq = 'sq',
  sr = 'sr',
  sv = 'sv',
  ta = 'ta',
  th = 'th',
  tr = 'tr',
  uk = 'uk',
  vi = 'vi',
  zhCN = 'zh-CN',
  zhTW = 'zh-TW'
}

export const BackendLocaleMap: Record<E_SupportedLocales, string> = {
  [E_SupportedLocales.af]: 'Af',
  [E_SupportedLocales.ar]: 'Ar',
  [E_SupportedLocales.be]: 'Be',
  [E_SupportedLocales.bg]: 'Bg',
  [E_SupportedLocales.bn]: 'Bn',
  [E_SupportedLocales.ca]: 'Ca',
  [E_SupportedLocales.cs]: 'Cs',
  [E_SupportedLocales.cy]: 'Cy',
  [E_SupportedLocales.da]: 'Da',
  [E_SupportedLocales.de]: 'De',
  [E_SupportedLocales.el]: 'El',
  [E_SupportedLocales.enUS]: 'Eng',
  [E_SupportedLocales.enGB]: 'EngGb',
  [E_SupportedLocales.eo]: 'Eo',
  [E_SupportedLocales.es]: 'Es',
  [E_SupportedLocales.et]: 'Et',
  [E_SupportedLocales.eu]: 'Eu',
  [E_SupportedLocales.fa]: 'Fa',
  [E_SupportedLocales.fi]: 'Fi',
  [E_SupportedLocales.fo]: 'Fo',
  [E_SupportedLocales.fr]: 'Fr',
  [E_SupportedLocales.ga]: 'Ga',
  [E_SupportedLocales.gl]: 'Gl',
  [E_SupportedLocales.gu]: 'Gu',
  [E_SupportedLocales.he]: 'He',
  [E_SupportedLocales.hi]: 'Hi',
  [E_SupportedLocales.hr]: 'Hr',
  [E_SupportedLocales.ht]: 'Ht',
  [E_SupportedLocales.hu]: 'Hu',
  [E_SupportedLocales.hy]: 'Hy',
  [E_SupportedLocales.id]: 'Id',
  [E_SupportedLocales.is]: 'Is',
  [E_SupportedLocales.it]: 'It',
  [E_SupportedLocales.ja]: 'Ja',
  [E_SupportedLocales.ka]: 'Ka',
  [E_SupportedLocales.kk]: 'Kk',
  [E_SupportedLocales.km]: 'Km',
  [E_SupportedLocales.kn]: 'Kn',
  [E_SupportedLocales.ko]: 'Ko',
  [E_SupportedLocales.ky]: 'Ky',
  [E_SupportedLocales.lb]: 'Lb',
  [E_SupportedLocales.lo]: 'Lo',
  [E_SupportedLocales.lt]: 'Lt',
  [E_SupportedLocales.lv]: 'Lv',
  [E_SupportedLocales.me]: 'Me',
  [E_SupportedLocales.mk]: 'Mk',
  [E_SupportedLocales.ml]: 'Ml',
  [E_SupportedLocales.mr]: 'Mr',
  [E_SupportedLocales.ms]: 'Ms',
  [E_SupportedLocales.my]: 'My',
  [E_SupportedLocales.nb]: 'Nb',
  [E_SupportedLocales.ne]: 'Ne',
  [E_SupportedLocales.nl]: 'Nl',
  [E_SupportedLocales.nn]: 'Nn',
  [E_SupportedLocales.paIN]: 'PaIN',
  [E_SupportedLocales.pl]: 'Pl',
  [E_SupportedLocales.pt]: 'Pt',
  [E_SupportedLocales.ro]: 'Ro',
  [E_SupportedLocales.ru]: 'Ru',
  [E_SupportedLocales.sk]: 'Sk',
  [E_SupportedLocales.sl]: 'Sl',
  [E_SupportedLocales.sq]: 'Sq',
  [E_SupportedLocales.sr]: 'Sr',
  [E_SupportedLocales.sv]: 'Sv',
  [E_SupportedLocales.ta]: 'Ta',
  [E_SupportedLocales.th]: 'Th',
  [E_SupportedLocales.tr]: 'Tr',
  [E_SupportedLocales.uk]: 'Uk',
  [E_SupportedLocales.vi]: 'Vi',
  [E_SupportedLocales.zhCN]: 'ZhCN',
  [E_SupportedLocales.zhTW]: 'ZhTW'
};
